import { FC } from "react";
import { MdsIconKind } from "@/design-system/components/icon";
import { MDSDropdownItem } from "./dropdown-list-item.types";
import { MDSComboboxListItemIcon } from "./dropdown-list-item-icon";
import { MDSComboboxListItemMetadata } from "./dropdown-list-item-metadata";
import {
  StyledListBoxItem,
  StyledContentContainer,
  StyledTitleRow,
  StyledTitle,
  StyledSharedIcon,
  StyledIconWrapper,
} from "./dropdown-list-item.style";
import { MDSListBoxSlotName } from "@/mds/components/lists/list-box-item";

type Props = {
  item: MDSDropdownItem;
  showMetadata?: boolean;
};

export const MDSDropdownListItem: FC<Props> = ({ item, showMetadata = true }) => {
  const metadata = item.metadata || {};
  const isShared = metadata.isShared as boolean | undefined;

  return (
    <StyledListBoxItem id={item.id} data-mds-name="combobox-list-item">
      <StyledIconWrapper slot={MDSListBoxSlotName.LeftAddon}>
        <MDSComboboxListItemIcon kind={item.kind} collectionId={item.id} />
      </StyledIconWrapper>
      <StyledContentContainer>
        <StyledTitleRow>
          <StyledTitle>{item.label}</StyledTitle>
          {isShared && <StyledSharedIcon kind={MdsIconKind.Shared} />}
        </StyledTitleRow>
        {item.kind !== "create-new-collection" && (
          <MDSComboboxListItemMetadata
            kind={item.kind}
            metadata={metadata}
            showMetadata={showMetadata}
          />
        )}
      </StyledContentContainer>
    </StyledListBoxItem>
  );
};
